/*
 * Fublic API Surface of ngx-firestate
 */
import { connect } from "react-redux";
import { ImportButton } from "./import-csv-button";
export { ImportButton };
export default connect()(ImportButton);
//# sourceMappingURL=index.js.map